
























import Vue from "vue";
import Pricing from "./Pricing.vue";

export default Vue.extend( {
  components: {Pricing},
  props   : {
    items : {
      type     : Array,
      required : true
    }
  },
  methods : {
    select( item: any ) {
      this.$emit( 'select', item );
    }
  }
} )
